import { ActionType, createReducer } from 'typesafe-actions';

import * as exchangeActions from './exchange.actions';
import { exchangeInitialState } from './exchange.initialState';

type State = typeof exchangeInitialState;
type Actions = ActionType<typeof exchangeActions>;

export const exchangeReducer = createReducer<State, Actions>(exchangeInitialState)
  .handleAction(exchangeActions.actionLoadingGetExchangeHistory, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(exchangeActions.actionSuccessGetExchangeHistory, (state, action) => ({
    ...state,
    history: action.payload.items || [],
    loading: false,
  }))
  .handleAction(exchangeActions.actionErrorGetExchangeHistory, (state) => ({
    ...state,
    loading: false,
    error: true,
  }))
  .handleAction(exchangeActions.actionLoadingGetExchangeSettings, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(exchangeActions.actionSuccessGetExchangeSettings, (state, action) => ({
    ...state,
    exchangeSettings: action.payload,
    loading: false,
  }))
  .handleAction(exchangeActions.actionErrorGetExchangeSettings, (state) => ({
    ...state,
    loading: false,
    error: true,
  }));
